export default "__VITE_ASSET__BVhzjEnS__"